var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 80,
    height: 2,
    viewBox: "0 0 80 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "header-underline",
    y1: 1,
    x2: 80,
    y2: 1,
    stroke: "#3B82F6",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderUnderline);
export default __webpack_public_path__ + "static/media/header-underline.06ba36637260174e66ada54adcd91cd4.svg";
export { ForwardRef as ReactComponent };